export {default} from './BonusesSection.connect';
